import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgLink = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.317 4.757l1.676 1.676c1.223 1.223 1.166 3.256-.12 4.542L16 13.847c-1.286 1.286-3.319 1.343-4.542.12l-1.117-1.117a.758.758 0 011.072-1.072l1.116 1.117c.626.626 1.702.578 2.4-.12L17.8 9.903c.698-.697.746-1.773.12-2.399L16.246 5.83c-.626-.626-1.702-.578-2.4.12l-2.22 2.221a.758.758 0 01-1.072-1.072l2.221-2.22c1.286-1.287 3.319-1.344 4.542-.12zM13.408 10.9l-1.117-1.116c-1.224-1.224-3.256-1.167-4.542.12l-2.872 2.871c-1.286 1.286-1.343 3.319-.12 4.542l1.676 1.676c1.223 1.223 3.256 1.166 4.542-.12l2.221-2.221a.758.758 0 00-1.072-1.072l-2.22 2.221c-.698.698-1.774.746-2.4.12L5.83 16.246c-.626-.626-.578-1.702.12-2.4l2.872-2.871c.697-.698 1.773-.746 2.399-.12l1.116 1.117a.758.758 0 001.072-1.072z"
      clipRule="evenodd"
    />
  </svg>
));
SvgLink.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgLink;
